import React, { useEffect, useState } from "react";
import { useShallowEqualSelector } from "../modules/hooks"
import { RootState } from "../store";
import styled, { css, StyledComponent } from "styled-components";
import { useSelector } from "react-redux";
import Loading from "./Loading";
import ReactECharts from 'echarts-for-react';
import ReactDOMServer from "react-dom/server";
import _ from 'lodash';
import globalValues from "../store/globalValues";

//region style
const Container = styled.div`
`;

const RowContainer = styled.div`
  color: white;
  overflow:auto;
  
  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      margin-bottom: 20px;
      height: 55vh;
      overflow-x: hidden;
      `;
    }
    else {
      return css`
      height: 580px;
      padding-left:30px;
      `;
    }
  }}
`;

const Row = styled.div`
  display:flex;
  align-items: center;
  
  ${(props) => {
    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
        padding: 6px 0 20px 0;
      `;
    }
    else {
      return css`
      padding: 18px 0;
      `;
    }
  }}
`;

const NameContainer = styled.div`
  font-family: -apple-system,BlinkMacSystemFont,"Microsoft JhengHei","Microsoft JhengHei UI","Microsoft YaHei","細明體_HKSCS","Kai_MSCS","Ming_MSCS","Ming-MSCS-DSI";
  font-weight: bold;
  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      font-size:40px;
      `;
    }
    else {
      return css`
      font-size:50px;
      width: 330px;
      `;
    }
  }}
`;

const Show = styled.div`
  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      //width: 120px;
      return css`
      width: 44vw;
      `;
    }
    else {
      return css`
      width: 190px;
      `;
    }
  }}
`;

const Text = styled.div`
  color:#106b64;
  font-weight: bold;

  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      font-size:20px;
      margin-bottom:6px;
      `;
    }
    else {
      return css`
      font-size:16px;
      margin-bottom:10px;
      `;
    }
  }}

`;
//color: rgb(27,150,157);

const Number = styled.div`
  
  color: white;
  font-weight: bold;
  -webkit-transform: scale(1.15,1);
  -ms-transform: scale(1.15,1);
  transform: scale(1.15,1);
  padding-left: 12px;
  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      font-size:36px;
      `;
    }
    else {
      return css`
      font-size:42px;
      `;
    }
  }}

`;

const Rank = styled.div`

  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      //width: 100px;
      return css`
      width: 32vw;
      `;
    }
    else {
      return css`
      width: 150px;
      `;
    }
  }}
`;

const BigYellowPerson = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    background-image: url("${process.env.PUBLIC_URL}/images/03-yellow-person.png");
    background-size: cover;
    color: rgb(28,149,158);
    font-weight: bold;
    width: 180px;
    height: 216px;
`;

const HeightSpace = styled.div`
  height: 40px;
`;

const HeadBox = styled.div`
  display:flex;
  justify-content: center;
  align-items: center;
  height: 128px;
  width: 128px;
`;

//////////////////////////////////
const Container0 = styled.div`
  display:flex;
  align-items: flex-start;
  height: auto;
  //max-height: 640px;
  //overflow: auto;
  color: #fafafa;

  .lastbar {
    height: 104px;
  }
  .color1 {
    background: rgb(253,200,0);
    color: rgb(4,106,92);
	}
	.color2 {
		background: rgb(27,150,158);
	}
	.color3 {
		background: rgb(122,185,174);
	}
  .color4 {
		background: rgb(46,167,224);
	}
  .color5 {
    background: rgb(173,207,255);
	}
  .color6 {
		background: rgb(205,193,253);
	}
  .color7 {
		background: rgb(251,115,155);
	}
  .barOpen, .barOpenLast {
    height: auto;
    .text-layer{
      margin-bottom: 10px !important;
      ${(props) => {
        if (props.theme.isMobile || props.theme.isTablet) {
          //width: 100px;
          return css`
            margin-bottom: 0 !important;
          `;
        }
      }}
    }
    .chart{
      height: fit-content;
      .echarts-for-react{
        margin-bottom: 40px;
      }
    }
  }
  .barClose {
    height: auto;
  }  
  .barOpenLast {
    margin-bottom: 10px;
    .chart{
      height: fit-content;
      .echarts-for-react{
        margin-bottom: 10px;
      }
    }
  }
  .barCloseLast {
    height: auto;
    margin-bottom: 10px;
  }
  .maxHeight {
    height: 1200px;
  }
 
  .chart {
    overflow: hidden;
    margin-top: 20px;
    transition: opacity .4s ease-in;
    opacity: 0;
    height: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight:bold;
    font-size:42px;
    ${(props) => {
      if (props.theme.isMobile || props.theme.isTablet) {
        //width: 100px;
        return css`
          margin-top: 0;
        `;
      }
    }}
  }
  .noDataText{
    //transform: translateY(-30px);
    margin-bottom: 50px;
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const Container1 = styled.div`
  display:flex;
  flex-direction: column;
  padding-top: 20px;
  width:100%;
  align-items: center;
`;

const Bar = styled.div`
  max-width: 900px;
  width: 100%;
	border-radius: 40px 40px 0 0;
	box-shadow: 0 -5px 40px rgba(0, 0, 0, 0.3);
  transition: height 0.5s ease 0s;
  cursor: pointer;
  margin: 0;
  margin-bottom: -36px;
`;

const TextLayer = styled.div`
  display:flex;
  align-items: center;
  padding-top: 24px;
  font-weight:bold;
  margin-bottom: 50px;
`;

const Container4 = styled.div`
  display:flex;
  align-items:center;
`;

const NameText = styled.div`
  font-size: 60px;
  padding-left:64px;
  width: 240px;
  font-family: -apple-system,BlinkMacSystemFont,"Microsoft JhengHei","Microsoft JhengHei UI","Microsoft YaHei","細明體_HKSCS","Kai_MSCS","Ming_MSCS","Ming-MSCS-DSI";
`;

const ShowTimeText = styled.div`
  font-size: 20px;
  padding-left:64px;
  width:230px;
  padding-top: 4px;
  text-align: right;
`;

const RankText = styled.div`
  font-size: 20px;
  padding-left:64px;
  padding-top: 4px;
  text-align: right;
`;

const NumberText  = styled.div<{ isText?: boolean; }>`
  width:130px;
  font-size: ${props => props.isText ? "20px" : "40px"};
  text-align: left;
  padding-top: ${props => props.isText ? "4px" : "0px"};
  padding-left: 30px;
`;


const TooltipContainer = styled.div`
  display:flex;
`;

const TooltipText = styled.div`
  display:flex;
  flex-direction: column;
`;

const TooltipNumber = styled.div`
  display:flex;
  flex-direction: column;
  padding-left:10px;
  text-align: right;
`;
// 3=36px 4=30px 5=24px 6=20px 7=17px

const SearchDataChart: React.FC<any> = (props: any) => {
  const searchNameInfo: any = useShallowEqualSelector((state: RootState) => state.storeSlice.searchNameInfo);
  const isMobile: any = useSelector((state: RootState) => state.storeSlice.isMobile);
  const isTablet: any = useSelector((state: RootState) => state.storeSlice.isTablet);
  const [name, setName] = useState(['']);
  const [count, setCount] = useState(['']);
  const [rank, setRank] = useState(['']);
  const [chartYear, setChartYear] = useState(['']);
  const [chartYearTotal, setChartYearTotal] = useState([[]]);
  const [chartYearRank, setChartYearRank] = useState(['']);
  const [type, setType] = useState(['']); //1單字 , 2姓 , 3名字
  const maxYear = globalValues.maxYear;
  const minYear = globalValues.minYear;

  const [scaleRate,setScaleRate] = useState(isMobile?0.8:1);
  useEffect(() => {
    setScaleRate(isMobile?0.6:1)
  }, [isMobile])

  const ShowDetailAuto = (targets: any) => {
    for (let i = 0; i < targets.length; i++) {
      let target = targets[i].firstElementChild;
      if(!target){
        continue;
      }
      if (target?.id != 'lastBar') {
        target?.classList.add("barOpen");
        target?.classList.remove("barClose");
        target?.setAttribute("data-status", "on");
        target.lastChild.style.opacity = 1;
      }
      else {
        target?.classList.add("barOpenLast");
        target?.classList.remove("barCloseLast");
        target?.setAttribute("data-status", "on");
        target.lastChild.style.opacity = 1;
      }
    }
  }

  useEffect(() => {
    if (searchNameInfo) {

      let nameArray: any[] = [];
      let countArray: any[] = [];
      let rankArray: any[] = [];
      let chartYearArray: any[] = [];
      let chartYearTotalArray: any[] = [];
      let chartYearRankArray: any[] = [];
      let typeArray: any[] = [];

      //searchNameInfo.name.map((m: any) => nameArray.push(m.name));
      searchNameInfo.familyName.map((m: any) => nameArray.push(m.name));
      searchNameInfo.nameWord.map((m: any) => nameArray.push(m.word));
      //setNameLength(searchNameInfo.nameWord.length);

      //searchNameInfo.name.map((m: any) => countArray.push(m.count));
      searchNameInfo.familyName.map((m: any) => countArray.push(m.count));
      searchNameInfo.nameWord.map((m: any) => countArray.push(m.count));

      //searchNameInfo.name.map((m: any) => rankArray.push(m.rank));
      searchNameInfo.familyName.map((m: any) => rankArray.push(m.rank));
      searchNameInfo.nameWord.map((m: any) => rankArray.push(m.rank));

      //searchNameInfo.name.map((m: any) => typeArray.push(3));
      searchNameInfo.familyName.map((m: any) => typeArray.push(2));
      searchNameInfo.nameWord.map((m: any) => typeArray.push(1));

      searchNameInfo.familyName.map((m: any) => chartYearArray.push(m.chartYear));
      searchNameInfo.nameWord.map((m: any) => chartYearArray.push(m.chartYear));

      searchNameInfo.familyName.map((m: any) => chartYearTotalArray.push(m.chartYearTotal));
      searchNameInfo.nameWord.map((m: any) => chartYearTotalArray.push(m.chartYearTotal));

      searchNameInfo.familyName.map((m: any) => chartYearRankArray.push(m.chartYearRank));
      searchNameInfo.nameWord.map((m: any) => chartYearRankArray.push(m.chartYearRank));


      setName(nameArray);
      setCount(countArray);
      setRank(rankArray);
      setType(typeArray);
      setChartYear(chartYearArray);
      setChartYearTotal(chartYearTotalArray);
      setChartYearRank(chartYearRankArray);

      setTimeout(() => {
        ShowDetailAuto(document.getElementsByClassName('barContainer'));
      }, 50);

    }
  }, [searchNameInfo]);

  useEffect(() => {
    setName([]);
    setCount([]);
    setRank([]);
    setType([]);
    setChartYear([]);
    setChartYearTotal([]);
    setChartYearRank([]);
  }, [props.reset]);

  const barHeightCover = 36*scaleRate;
  const lastBarHeight = 104*scaleRate;
  const otherBarHeight = lastBarHeight + barHeightCover;
  const chartHeight = 400*scaleRate;

  const ShowDetail = (e: any) => {
    e.currentTarget.parentNode.style.height = 'auto';
    const status = e.currentTarget.getAttribute("data-status");
    const sequence = e.currentTarget.getAttribute("data-sequence");
    var div = e.currentTarget.parentNode.parentNode.parentNode.parentNode;
    for (let i = 0; i < e.currentTarget.parentElement.children.length; i++) {
      e.currentTarget.parentElement.children[i].lastChild.style.opacity = 0;
      // e.currentTarget.parentElement.children[i].lastChild.style.display="none";
      e.currentTarget.parentElement.children[i].setAttribute("data-status", "off");
      if (i != e.currentTarget.parentElement.children.length - 1) {
        e.currentTarget.parentElement.children[i].classList.remove("barOpen");
        e.currentTarget.parentElement.children[i].classList.add("barClose");
      }
      else {
        e.currentTarget.parentElement.children[i].classList.remove("barOpenLast");
        e.currentTarget.parentElement.children[i].classList.add("barCloseLast");
      }
    }


    if (e.currentTarget.id != 'lastBar') {
      if (status == 'off') {
        // e.currentTarget.parentNode.style.height=(14+lastBarHeight*e.currentTarget.parentElement.children.length+chartHeight)+'px';
        e.currentTarget.classList.add("barOpen");
        e.currentTarget.classList.remove("barClose");
        e.currentTarget.setAttribute("data-status", "on");
        e.currentTarget.lastChild.style.opacity = 1;
        // e.currentTarget.lastChild.style.display="unset";
        if (sequence != 1) {
          e.currentTarget.addEventListener("animationend",
            div.scroll({
              top: (sequence - 1) * 98 + 34,
              behavior: 'smooth'
            })
          )
        }
        else {
          e.currentTarget.addEventListener("animationend",
            div.scroll({
              top: 0,
              behavior: 'smooth'
            })
          )
        }
      }
      else {
        e.currentTarget.classList.add("barClose");
        e.currentTarget.classList.remove("barOpen");
        e.currentTarget.setAttribute("data-status", "off");
        e.currentTarget.lastChild.style.opacity = 0;
        // e.currentTarget.lastChild.style.display="none";
      }
    }
    else {
      if (status == 'off') {
        // e.currentTarget.parentNode.style.height=(14+lastBarHeight*e.currentTarget.parentElement.children.length+chartHeight)+'px';
        e.currentTarget.classList.add("barOpenLast");
        e.currentTarget.classList.remove("barCloseLast");
        e.currentTarget.setAttribute("data-status", "on");
        e.currentTarget.lastChild.style.opacity = 1;
        // e.currentTarget.lastChild.style.display="unset";
        if (sequence != 1) {
          e.currentTarget.addEventListener("animationend",
            div.scroll({
              top: (sequence - 1) * 98 + 30,
              behavior: 'smooth'
            })
          )
        }
        else {
          e.currentTarget.addEventListener("animationend",
            div.scroll({
              top: 0,
              behavior: 'smooth'
            })
          )
        }
      }
      else {
        e.currentTarget.classList.add("barCloseLast");
        e.currentTarget.classList.remove("barOpenLast");
        e.currentTarget.setAttribute("data-status", "off");
        e.currentTarget.lastChild.style.opacity = 0;
        // e.currentTarget.lastChild.style.display="none";
      }
    }
  }

  const options = (year: any, total: any, rank: any, isFamilyName: any) => {
    return {
      grid: {
        containLabel: true,
        top: 50,
        bottom: 40,
        left: 70*scaleRate,
        right:40*scaleRate,
      },
      xAxis: {
        name: '年份',
        nameLocation: 'center',
        nameTextStyle: {
          fontSize: 16*scaleRate,
          padding: [24*scaleRate, 36*scaleRate, 0, 0]
        },
        type: 'category',
        data: year,
        triggerEvent: false,
        axisLine: {
          lineStyle: {
            color: '#FFFFFF',
            width: 4*scaleRate,
          }
        },
        axisTick: {
          alignWithLabel: true,
          inside: true,
          length: 10*scaleRate,
          lineStyle: {
            width: 4*scaleRate,
          }
        },
        axisLabel: {
          show: true,
          interval: (index: number) => {
            if (index % 5 == 0) {
              return true
            }
            else if (index == (maxYear - minYear)) {
              return true
            }
          },
          textStyle: {
            fontSize: 17*scaleRate
          },
          padding: [6*scaleRate, 0, 0, 0]
        },
      },
      yAxis: {
        name: '出現次數',
        nameTextStyle: {
          fontSize: 16*scaleRate,
          padding: [0, 44*scaleRate, 10*scaleRate, 0]
        },
        type: 'value',
        min: function (value: any) { return Math.floor(value.min / 10) * 10 },
        max: function (value: any) { return Math.ceil(value.max / 10) * 10 },
        splitNumber: 4,
        splitLine: {
          show: false
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: '#FFFFFF',
            width: 4*scaleRate,
          }
        },
        axisLabel: {
          show: true,
          textStyle: {
            fontSize: 18*scaleRate
          },
          padding: [0, 20*scaleRate, 0, 0]
        }
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: "cross",
          label: {
            show: false
          },
          lineStyle: {
            width: 2*scaleRate,
            type: [4, 3],
            cap: 'butt',
            color: "#000000"
          },
          crossStyle: {
            color: '#000',
            width: 2*scaleRate,
            type: [4, 3],
            cap: 'butt',
          }
        },
        backgroundColor: 'rgb(4,106,92)',
        borderColor: 'rgb(62,146,133)',
        borderWidth: 1,
        borderRadius: 0,
        textStyle: {
          color: "#FFFFFF",
        },
        formatter: function (params: any) {
          const htmlString = ReactDOMServer.renderToStaticMarkup(
            <div>
              <div>{params[0].axisValue}年</div>
              <TooltipContainer>
                <TooltipText>
                  <div>{isFamilyName ? '姓氏出現次數' : '名字單字出現次數'} :</div>
                  <div>排名 :</div>
                </TooltipText>
                <TooltipNumber>
                  <div>{params[0].value}</div>
                  <div>{rank[params[0].dataIndex]}</div>
                </TooltipNumber>
              </TooltipContainer>
            </div>
          );
          return htmlString
        }
      },
      series: [
        {
          data: total,
          type: 'line',
          symbol: 'circle',
          symbolSize: 1,
          lineStyle: {
            normal: {
              width: 4*scaleRate,
              color: '#FFF'
            }
          },
          itemStyle: {
            normal: {
              color: '#FFF',//拐点颜色
              borderColor: isFamilyName ? 'rgb(4,106,92)' : 'rgb(253,200,0)',//拐点边框颜色
              borderWidth: 0//拐点边框大小
            },
            emphasis: {
              color: isFamilyName ? 'rgb(4,106,92)' : 'rgb(253,200,0)',//hover拐点颜色定义
              borderColor: isFamilyName ? 'rgb(4,106,92)' : 'rgb(253,200,0)',//拐点边框颜色
              borderWidth: 12*scaleRate//拐点边框大小
            }
          },
        }
      ]
    }
  }

  const GenBar = () => {

    let result = [];
    let sequenceNumber = 0;

    for (let i = 1; i <= name.length; i++) {
      let showChart = false;
      let showChartByCount = true;
      let showChartByCountText = "";

      for (let j = 0; j < chartYearTotal[i - 1].length; j++) {
        let itemTotal = chartYearTotal[i - 1][j]
        if (itemTotal != 0) {
          showChart = true;
          break;
        }
      }

      if(!_.reduce(chartYearTotal[i - 1], (p: any, c: any) => {
        return !isNaN(parseInt(c)) && parseInt(c) !== 0 ? true : p
      }, false)){
        showChartByCount = false;
      }

      if(!showChartByCount){
        showChartByCountText = _.reduce<any, any>(chartYearTotal[i - 1], (p: any, c: any) => isNaN(parseInt(c)) ? c : p, "");
      }

      const ReturnChart = (props: any) => {
        let chartDiv = [];

        if (showChart && showChartByCount) {
          chartDiv.push(
            <div className="chart">
              <ReactECharts option={options(chartYear[i - 1], chartYearTotal[i - 1], chartYearRank[i - 1], props.isFamilyName)} style={{ width: '100%', height: `${400*scaleRate}px` }} />
            </div>
          )
        }
        else {
          chartDiv.push(
            <div className="chart">
              <div className="noDataText">{!showChart ? "沒有出現次數" : !showChartByCount ? showChartByCountText : ""}</div>
            </div>
          )
        }
        return (
          <>
            {chartDiv}
          </>
        )
      }

      if (name[i - 1].length > 0) {
        if (type[i - 1] == '2' && i != name.length) {
          sequenceNumber++;
          result.push(
            <Bar className={"color" + i + " barClose"} onClick={ShowDetail} key={i} data-status='off' data-sequence={sequenceNumber}>
              <TextLayer className={'text-layer'}>
                <NameText>{name[i - 1]}</NameText>
                <Container4>
                  <ShowTimeText>姓氏出現次數</ShowTimeText>
                  <NumberText isText={isNaN(parseInt(count[i - 1]))}>{count[i - 1]}</NumberText>
                </Container4>
                <Container4>
                  <RankText>排名</RankText>
                  <NumberText>{rank[i - 1]}</NumberText>
                </Container4>
              </TextLayer>
              <ReturnChart isFamilyName={true} />
            </Bar>
          )
        }
        else if (type[i - 1] == '2' && i == name.length) {
          sequenceNumber++;
          result.push(
            <Bar className={"color" + i + " barCloseLast"} id='lastBar' onClick={ShowDetail} key={i} data-status='off' data-sequence={sequenceNumber}>
              <TextLayer className={'text-layer'}>
                <NameText>{name[i - 1]}</NameText>
                <Container4>
                  <ShowTimeText>姓氏出現次數</ShowTimeText>
                  <NumberText isText={isNaN(parseInt(count[i - 1]))}>{count[i - 1]}</NumberText>
                </Container4>
                <Container4>
                  <RankText>排名</RankText>
                  <NumberText>{rank[i - 1]}</NumberText>
                </Container4>
              </TextLayer>
              <ReturnChart isFamilyName={true} />
            </Bar>
          )
        }
        else if (i != name.length) {
          sequenceNumber++;
          result.push(
            <Bar className={"color" + i + " barClose"} onClick={ShowDetail} key={i} data-status='off' data-sequence={sequenceNumber}>
              <TextLayer className={'text-layer'}>
                <NameText>{name[i - 1]}</NameText>
                <Container4>
                  <ShowTimeText>名字單字出現次數</ShowTimeText>
                  <NumberText isText={isNaN(parseInt(count[i - 1]))}>{count[i - 1]}</NumberText>
                </Container4>
                <Container4>
                  <RankText>排名</RankText>
                  <NumberText>{rank[i - 1]}</NumberText>
                </Container4>
              </TextLayer>
              <ReturnChart />
            </Bar>
          )
        }
        else {
          sequenceNumber++;
          result.push(
            <Bar className={"color" + i + " barCloseLast"} id='lastBar' onClick={ShowDetail} key={i} data-status='off' data-sequence={sequenceNumber}>
              <TextLayer className={'text-layer'}>
                <NameText>{name[i - 1]}</NameText>
                <Container4>
                  <ShowTimeText>名字單字出現次數</ShowTimeText>
                  <NumberText isText={isNaN(parseInt(count[i - 1]))}>{count[i - 1]}</NumberText>
                </Container4>
                <Container4>
                  <RankText>排名</RankText>
                  <NumberText>{rank[i - 1]}</NumberText>
                </Container4>
              </TextLayer>
              <ReturnChart />
            </Bar>
          )
        }
      }
    }

    return (
      <Container0 className={'popup-chart-modal-main'}>
        <Container1 className="barContainer" >
          {result}
        </Container1>
      </Container0>
    )

  }

  return (
    <Container key={0}>
      {
        searchNameInfo &&
        <GenBar />
      }
      {
        !searchNameInfo &&
        <Loading></Loading>
      }
      {
        searchNameInfo && props.children
      }
    </Container>
  );

};

export default SearchDataChart;
